export const headingAndTextarea = {
  subheading: 'Условия оплаты, доставки и возврата',
  heading: 'Утром деньги, вечером стулья',
  headingType: 'primary',
}
